import initMapContact from './modules/init-map-contact';

window.addEventListener('load', () => {
  initMapContact();
});
